import { Flex } from "@chakra-ui/react";
import { Fragment } from "react";
import ReusableEmployeeHeader from "../../UI/ReusableEmployeeHeader";
import { FiEdit2 } from "react-icons/fi";
import EditTab from "./EditTab";

export default function EditContainer() {
  return (
    <Fragment>
      <Flex
        w="100%"
        align="start"
        direction="column"
        h="100%"
        gap="1rem"
        p={{ lg: "2rem", md: "1rem", base: "6px" }}
      >
        <ReusableEmployeeHeader
          title="Profile"
          text="Manage your employees and their details here"
        />
        <EditTab />
      </Flex>
    </Fragment>
  );
}
